const userLang = navigator.language || navigator.userLanguage;

// --- Status Mapping ---
export const getItemStatusInfo = (status, isMerchantView = false) => {
  status = status?.toLowerCase();
  let text = '';
  let colorName = 'gray'; // Default color name

  switch (status) {
    case 'pending':
      text = userLang === 'zh-CN' ? '待确认' : 'Pending Confirmation'; colorName = 'yellow'; break;
    case 'coordinating_pickup':
      text = userLang === 'zh-CN' ? '协调取货中' : 'Coordinating Pickup'; colorName = 'blue'; break;
    case 'processing':
      text = userLang === 'zh-CN' ? '处理中' : 'Processing'; colorName = 'blue'; break;
    case 'shipped':
      text = userLang === 'zh-CN' ? '已发货' : 'Shipped'; colorName = 'purple'; break;
    case 'delivered':
      text = userLang === 'zh-CN' ? '已送达' : 'Delivered'; colorName = 'green'; break;
    case 'in_use':
      text = userLang === 'zh-CN' ? '租用中' : 'Rental Active'; colorName = 'teal'; break;
    case 'return_requested_by_customer':
      text = userLang === 'zh-CN' ? '退货请求中' : 'Return Requested'; colorName = 'orangeYellow'; break;
    case 'return_approved_by_merchant':
      if (isMerchantView) {
        text = userLang === 'zh-CN' ? '等待退货' : 'Waiting Return';
      } else {
        text = userLang === 'zh-CN' ? '退货已批准' : 'Return Approved';
      }
      colorName = 'teal'; break;
    case 'return_rejected_by_merchant':
      text = userLang === 'zh-CN' ? '退货已拒绝' : 'Return Rejected'; colorName = 'red'; break;
    case 'return_pending':
      text = userLang === 'zh-CN' ? '申请退货中' : 'Return Requested'; colorName = 'orangeYellow'; break;
    case 'return_shipped':
      text = userLang === 'zh-CN' ? '退货已发出' : 'Return Shipped'; colorName = 'purple'; break;
    case 'return_delivered':
      text = userLang === 'zh-CN' ? '退货已收到' : 'Return Received'; colorName = 'gray'; break;
    case 'completed':
      text = userLang === 'zh-CN' ? '已完成' : 'Completed'; colorName = 'green'; break;
    case 'canceled':
      text = userLang === 'zh-CN' ? '已取消' : 'Canceled'; colorName = 'red'; break;
    case 'returned':
      text = userLang === 'zh-CN' ? '已退回' : 'Returned'; colorName = 'gray'; break;
    default:
      text = status ? status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : (userLang === 'zh-CN' ? '未知' : 'Unknown');
      colorName = 'gray';
  }
  return { text, colorName };
};

export const itemStatusBadgeColorClasses = {
  gray: 'bg-gray-100 text-gray-700',
  yellow: 'bg-yellow-100 text-yellow-700',
  blue: 'bg-blue-100 text-blue-700',
  green: 'bg-green-100 text-green-700',
  red: 'bg-red-100 text-red-700',
  orange: 'bg-brand-orange-light text-brand-orange-dark',
  orangeYellow: 'bg-yellow-100 text-orange-600', // Orange text on yellow background for return requests
  purple: 'bg-purple-100 text-purple-700',
  teal: 'bg-brand-teal-light-hover text-brand-teal-dark',
  default: 'bg-gray-100 text-gray-700', // Fallback
}; 